module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/circle_sp-c78b72dbd68c0e123fede89817906a67.svg";